import { sort } from 'fast-sort'
import { isAmbevProjects } from './filterProjects';

export const formattedList = (data, year) => {
  let newData = [...new Set(data.filter(item => item && item?.Trilha).map( item => item?.Trilha.toUpperCase()))] || [];
  if(year) data = data.filter(item => item && item?.year_trilha == year);
  
  if(!year) {
    const years = [...new Set([...data.map(item => item?.year_trilha)])].sort((a,b) => b-a);
    year = years[0];
  }

  const loadNewData = newData.map( item => {
    let Produtores = [];
    let contagem_projeto = 0;
    let num_jornada_completa = 0;
    let itensToReturn = {};

    data
      .filter(trail => trail && trail.Trilha?.toUpperCase() === item.toUpperCase())
      .map( trail => {
        if(trail.year_trilha == year) {
          itensToReturn = trail;
          Produtores = [...Produtores, ...trail?.Produtores];
          contagem_projeto = trail?.contagem_projeto;
          num_jornada_completa += getPercent(trail?.Produtores || [], trail?.contagem_projeto, year)[0] || 0;
        }
      });

    return {
      ...itensToReturn,
      Produtores,
      contagem_projeto,
      num_jornada_completa
    }
  }).filter(item => item && item.Trilha)

  return loadNewData
}

export const getYearProducers = (data, trail, year) => {
  const yearList = [...new Set(data.map( item => item.year_trilha).sort((a,b) => b - a))];
  
  if(!year) year = yearList[0];
  
  const currentFormattedData = formattedList(data, year).filter(item => item && item?.Trilha.toUpperCase() === trail.toUpperCase());


  return getPercent(currentFormattedData[0]?.Produtores, currentFormattedData[0]?.contagem_projeto, year)[0];
}

export const getYearPercent = (data, trail, year, projectId, totalProducers = 1, valueNumber = false) => {
  const yearList = [...new Set(data.map( item => item.year_trilha).sort((a,b) => b - a))];

  if(!year) year = yearList[0];

  const currentFormattedData = formattedList(data, year).filter(item => item && item?.Trilha.toUpperCase() === trail.toUpperCase());
  const producersNumber = getPercent(currentFormattedData[0].Produtores, currentFormattedData[0]?.contagem_projeto, year)[0] || 0;
  
  const goal = getGoal(projectId, year, trail, parseInt(totalProducers)) || 1;
  const percent = ((parseInt(producersNumber) * 100) / goal).toFixed(0) || 0;

  if(valueNumber) {
    return { value: percent, number: parseInt(producersNumber) - goal}
  } else {
    return percent;
  }

}

export const getPercent = (producers = [], totalProjects = 1, year) => {
  let fullJourney = 0;
  
  producers.map( producer => {
    if(year == producer?.ano) {
      if(producer?.NumeroDeItens <= producer?.CountVisualizado)
        fullJourney++
    }

    return producer
  })

  return [fullJourney, ((fullJourney*100) / (totalProjects)) || 0];
}

export const formattedBar = (projectId, data = [], year = '') => {
  if(year) {
    data = data.filter(item => item.year_trilha == year)
  }
  
  const singleArray = [...new Set(data.map(item => item?.year_trilha)) || []]
  const filteredArray = singleArray.map(item => {
    const filteredYears = data.filter(row => row.year_trilha === item)

    const filterProjects = filteredYears.map(value => {
      const filter = sort(data.filter(row => value && value.Trilha.toUpperCase() === row?.Trilha.toUpperCase() && row?.year_trilha === item)).desc(u => u.month)
      return filter[filter.length - 1]
    })

    const valueFormatted = removeDuplicates(filterProjects.map(row => {
      const totalValue = formattedList(data, row?.year_trilha)
      .filter(dt => dt && row && dt.Trilha.toUpperCase() === row?.Trilha.toUpperCase());

      return {
        value: getYearPercent(data, row.Trilha, year, row?.Projeto, row?.contagem_projeto || 0),
        number: parseInt(totalValue[0]?.num_jornada_completa || 0),
        goal: getGoal(projectId, row?.year_trilha, row?.Trilha, parseInt(row?.contagem_projeto)),
        goalLabel: `Meta ${row && row.Trilha}`,
        label: row && row.Trilha,
        goalPercent: 100
      }
    }))

    const group = _.groupBy(valueFormatted, 'label')

    let itemObject = {
      name: item,
      ...group,
      "Total do projeto": getTotalProject(data, item),
      // "Total do projeto": formattedArrayLine(data).find(value => value.year === item)['Total do projeto'],
      // "Meta": formattedArrayLine(data).find(value => value.year === item)['Meta'],

    }
    return itemObject
  })

  return filteredArray
}

export const getTotalProject = (data, year) => {
  return data.filter(item => item.year_trilha === year)[0].contagem_projeto || 0;
}

const goals = {
  "ambev": {
    'conectado': {
      '2021': 40,
      '2022': 40,
      '2023': 70
    },
    'capacitado': {
      '2021': 40,
      '2022': 20,
      '2023': 70
    },
    'empoderado financeiramente': {
      '2021': 20,
      '2022': 40,
      '2023': 75
    },
  },
  "7545f50b-5ab5-462c-82c6-92719c990c03": {
    'conectado': {
      '2023': 50
    },
    'capacitado': {
      '2023': 40
    },
    'empoderado financeiramente': {
      '2023': 40
    },
  }
}

const toGoal = (projectId, year, trilhaUpper, numProject) => {
  const trilha = `${trilhaUpper}`.toLowerCase();
  if(isAmbevProjects(projectId)){
    return goals['ambev'][trilha] && goals['ambev'][trilha][year] && numProject*(goals['ambev'][trilha][year]/100) || 0;
  } else {
    return goals[projectId] && goals[projectId][trilha] && goals[projectId][trilha][year] && numProject*(goals[projectId][trilha][year]/100) || numProject * 0.8
  }
}

export const getGoal = (projectId, year, trilhaUpper, numProject) => {
  const goal = toGoal(projectId, year, trilhaUpper, numProject)
  return Math.floor(goal);
}

export const formattedArrayLine = (data) => {
  const singleArray = [...new Set(data.map(item => item.year_trilha))]
  const filteredArray = singleArray.map(item => {
    const filteredYears = data.filter(row => row.year_trilha === item)
    const filterProjects = filteredYears.map(value => {
      const filter = sort(data.filter(row => value.Trilha === row.Trilha && row.year_trilha === item)).desc(u => u.month)
      return filter[filter.length - 1]
    })
    const valueFormatted = removeDuplicates(filterProjects.map(row => {
      return {
        name: item,
        value: parseInt(row.contagem_projeto),
        goal: getGoal(projectId, row.year_trilha, row.Trilha, parseInt(row.contagem_projeto)),
        label: row && row.Trilha,
      }
    }))
    const order = sort(valueFormatted).asc(u => u.value)
    let itemObject = {}

    const array = [...Array(2)].map(item => {
      itemObject = {
        // 'Meta': ,
        "Total do projeto": order[order.length - 1].value,
        year: order[order.length - 1].name
      }

      return item
    })
    return itemObject

  })
  return filteredArray

}

export const formattedArrayBars = (data) => {
  return removeDuplicates(data.map(item => {
    return {
      Trilha: item.Trilha,
      color: gerar_cor_hexadecimal()
    }
  }), true)
}

const removeDuplicates = (data, field) => {
  return data.filter(function (a) {
    return !this[JSON.stringify(field ? a.Trilha : a)] && (this[JSON.stringify(field ? a.Trilha : a)] = true);
  }, Object.create(null))
}

function gerar_cor_hexadecimal() {
  return '#' + parseInt((Math.random() * 0xFFFFFF))
    .toString(16)
    .padStart(6, '0');
}
